class NomeUtil {
    /**
     * Ajusta o nome considerando a variação adequada maiúsculas e minúsculas.
     *
     * @public
     * @param {string} nomeParaAjustar O nome a ser ajustado, em caixa alta.
     * @returns {string} O nome ajustado. Se o parâmetro informado não estiver inteiramente em caixa alta, retorna o próprio parâmetro de entrada.
     */
    static ajustarCaixaNomeProprio(nomeParaAjustar) {
        if (nomeParaAjustar.match(/[a-z]/)) {
            return nomeParaAjustar;
        } else {
            let nomeAjustado = nomeParaAjustar.toLowerCase();
            nomeAjustado = this.ajustarPrimeiraLetra(nomeAjustado, ' ');
            nomeAjustado = this.ajustarPrimeiraLetra(nomeAjustado, '-');
            return nomeAjustado.trim();
        }
    }

    /**
     * Colocar primeira letra dos nome dentro do nome completo em maiúscula, com exceções de de, das e etc.
     * @param {String} nome O nome completo a ser ajustado
     * @param {String} separador Separador que identifica as formas de separar os nomes dentro do nome completo
     * @returns
     */
    static ajustarPrimeiraLetra(nome, separador) {
        return nome
            .split(separador)
            .map((t) =>
                (t.length <= 2 && !t.includes('.')) || t === 'dos' || t === 'das'
                    ? t
                    : t[0].toUpperCase() + t.substring(1)
            )
            .join(separador);
    }

    /**
     * @private
     * @param {Array} palavra Array de 1 posição, com a parte do nome
     * @returns {string} A parte do nome acrescida de um ponto (.)
     */
    static abreviarNomeUnico(palavra) {
        // Se vazio ou minúsculo
        if (palavra.length === 0 || !palavra[0].match(/[A-Z]/)) {
            return '';
        } else {
            return palavra[0] + '.';
        }
    }

    /**
     * Abrevia o nome.
     *
     * @public
     * @param {string} nome O nome a ser abreviado.
     * @returns {string} A abreviação do nome.
     */
    static abreviarNome(nome) {
        let nomeCaixaAjustada = NomeUtil.ajustarCaixaNomeProprio(nome);
        return nomeCaixaAjustada
            .split(' ')
            .map((n) => NomeUtil.abreviarNomeUnico(n))
            .reduce((acc, cur) => acc + cur, '');
    }

    /**
     * Remove os acentos e codifica o texto em caixa alta.
     *
     * @public
     * @param {string} txt O texto a ser ajustado.
     * @returns {string} O texto com caracteres correspondentes.
     */
    static toCaixaAltaSemAcento(txt) {
        if (txt) {
            let caracteresATrocar = 'ÃÁÀÂÄÉÈÊËÍÌÎÏÕÓÒÔÖÚÙÛÜÑÇ';
            let caracteresTrocados = 'AAAAAEEEEIIIIOOOOOUUUUNC';
            txt = txt.toUpperCase();

            for (let i = 0; i < caracteresATrocar.length; i++) {
                txt = txt.replace(new RegExp(caracteresATrocar[i], 'g'), caracteresTrocados[i]);
            }
            return txt.trim();
        }
        return txt;
    }

    /**
     * Compara dois textos, desconsiderando acentos e ignorando maiúsculas e minúsculas.
     *
     * @public
     * @param {string} txt1 O texto 1.
     * @param {string} txt2 O texto 2.
     * @returns {boolean} Indica se os textos são iguais (true) ou não (false).
     */
    static comparaNomesAjustandoAcentos(txt1, txt2) {
        return NomeUtil.toCaixaAltaSemAcento(txt1) === NomeUtil.toCaixaAltaSemAcento(txt2);
    }
}

export default NomeUtil;
